export default __webpack_public_path__ + "static/media/บอลสเต็ปตายหมดรับฟรีv2.8bc1d8b9.png";